import {
  StyleSheet,
  css
} from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';

export const Styles = StyleSheet.create({
  innerContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  editContent: {
    cursor: 'pointer',
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: AppTheme.secondaryColor
    }
  },
  innerTableContent: {
    backgroundColor: '#202633',
    padding: '22px 25px',
    margin: '10px 0 0 0',
    display: 'flex',
  },
  innerMainContent: {
    display: 'flex',
    width: '90%',
    flexDirection: 'column'
  },
  orgDetailContainer: {
    display: 'flex',
    marginTop: 20
  },
  orgDetailInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: .5,
  },
  orgDetailInnerContainerSecondary: {
    marginLeft: 15
  },
  orgDetailContainerTilte: {
    display: 'flex',
    backgroundColor: AppTheme.primaryBackground,
    padding: 15,
    borderRadius: '8px 8px 0px 0px'
  },
  orgDetailContainerTiltContent: {
    margin: 0,
    color: AppTheme.white,
    opacity: 0.6
  },
  orgDetailInnerContent: {
    backgroundColor: '#202633',
    display: 'flex',
    padding: 15,
    borderRadius: '0px 0px 8px 8px',
    flex: 1
  },
  ImgOuterContainer: {
    maxWidth: 150,
    display: 'flex',
    borderRadius: 5,
    marginRight: 15
  },
  ImgContent: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  overrallContainer: {
    marginLeft: 35
  },
  overrallContainerTitle: {
    margin: 0,
    opacity: 0.6,
    color: AppTheme.white,
    fontSize: 11,
    fontWeight: 'bold',
  },
  overrallContainerContent: {
    color: '#2CB673',
    fontSize: 48,
    fontWeight: 300,
    margin: 0,
  },
  overrallContainerContentThird: {
    color: 'orange'
  },
  tableInnerContent: {
    opacity: .8
  }
})


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/Styles.js